.root {
  padding: var(--spacingMd);
  display: flex;
  align-items: center;
  gap: var(--spacingMd);
}
